import { useState, useEffect, useRef, RefObject } from 'react'

export type HorizontalScrollState = {
  scrollBarState: {
    left: boolean
    right: boolean
  }
  maxScrollLeft: RefObject<number>
}

function useHorizontalScrollState(
  scrollArea: RefObject<HTMLDivElement>,
  scrollLeft: number
): HorizontalScrollState {
  const [scrollBarState, setScrollBarState] = useState({
    left: false,
    right: true,
  })
  const maxScrollLeft = useRef(
    scrollArea.current
      ? scrollArea.current.scrollWidth - scrollArea.current.clientWidth
      : 10000000000
  )

  useEffect(() => {
    /* Recaptures maxScrollLeft if default value was given once scrollArea is referenced */
    if (scrollArea.current) {
      maxScrollLeft.current =
        scrollArea.current.scrollWidth - scrollArea.current.clientWidth
    }
    /* Measures the different scroll bar states */
    if (scrollLeft > 0 && scrollLeft < maxScrollLeft.current) {
      setScrollBarState({ left: true, right: true })
    } else if (scrollLeft === 0) {
      setScrollBarState({ left: false, right: true })
    } else if (scrollLeft === maxScrollLeft.current) {
      setScrollBarState({ left: true, right: false })
    }
  }, [scrollLeft, scrollArea])

  return { scrollBarState, maxScrollLeft }
}

export { useHorizontalScrollState }
